let pop_name, pop_address, pop_phone, pop_flag_newPatient, pop_website, pop_types_patients
let pop_langs, pop_insurances, pop_providers,pop_display;
let pop_clickme;
let pop_clickable;
let markerL;//a marker created by geolocating

function translate_lang(str){
    let langs = {
        'Italian':"Italiano",
        'Creole':"Criollo",
        'French':"Francés",
        'Hebrew':"Hebreo",
        'Hindi':"Hindi",
        'Urdu':"Urdu",
        'Italina':"Italiano",
        'Translation services available if needed':"Servicios de traduccion disponibles si es necesario",
        'Russian':"Ruso",
        'Polish':"Polaco",
        'Cambodian':"Camboyano",
        'Arabic':"Arábica",
        'Farsi':"Farsi"
    };
    for (let key in langs) {
        str = str.replace(key, langs[key]);
    }
    return str;
}
/*function translate_newPatients(str) {
    let pairs = {
        "Yes": "Sí",
        "No": "No"
    }
    return pairs[str];

}*/
/*function translate_typePatients(str){
    let pairs = {
        'All': "Todos",
        'Newborns': "Recién nacidos",
        'Other': "Otro",
        'Call the office for details': "Comuniquese a la oficina para detalles",
        'Dr Amaio, Dr. Ullman and Dr. Dierolf are accepting new pediatric patients of all ages.': "Dr. Amaio, Dr. Ullman y Dr. Dierolf estan aceptando pacientes pediatricos de todas las edades",
        'Only accepting new patients for those who have siblings in practise': "Solo acepta pacientes nuevos para aquellos que tienen hermanos en la práctica",
        'Accepting patients for allergy care and some pediatric care': "Aceptando pacientes para cuidado de alergias y algun cuidado pediatrico",
        'Also accepting very young children': "También se aceptan menores",
        'Accepting only GYN patients at this time':"Solo aceptando pacientes de ginecología",
        'Only accepting adults at this time': "En este momento solo acceptamos a adultos",
        'Children over 12yrs old and adults only at this time': "A este tiempo, solamente niños arriba de 12 años y adultos",
        'Dr. Macfarlan will be joining this practice in late September.': "Dr. Macfarlan estará  en esta practica afinales de septiembre."

    }
    for (let key in pairs) {
        str = str.replace(key, pairs[key]);
    }
    return str;
}*/

function setPopVars(feature) {
    let attrs = feature.properties;
    pop_name = attrs.USER_Practice_name;
    pop_address = `${attrs.USER_Address1 == undefined? '':attrs.USER_Address1}, 
    ${attrs.USER_Address2== undefined? '':attrs.USER_Address2}, 
    ${attrs.USER_City == undefined? '': attrs.USER_City}, 
    ${attrs.USER_State == undefined? '':attrs.USER_State}, 
    ${attrs.USER_Zip == undefined? '':attrs.USER_Zip}`
    pop_phone = attrs.USER_practice_phone;
    pop_website = attrs.USER_practice_website == undefined? undefined: (attrs.USER_practice_website.includes('http')? attrs.USER_practice_website:undefined);
    pop_clickme = pop_website == undefined? 'No disponible': 'Haga click aquí';
    pop_clickable = pop_website == undefined? 'disabled': '';
    pop_flag_newPatient = attrs.USER_acceptingnewpatients;
    pop_display = pop_flag_newPatient.toLowerCase() == 'sí'? '':'d-none';
    pop_types_patients = pop_display == 'd-none'? '': `${attrs.USER_accepting_new_type}${attrs.USER_accepting_new_type_other_d == undefined? '':`, ${attrs.USER_accepting_new_type_other_d}`}`;
    pop_langs = `${attrs.USER_lang_english.toLowerCase() == 'sí'? 'Inglés':''}${attrs.USER_lang_spanish.toLowerCase() == 'sí'? ', Español':''}${attrs.USER_lang_portuguese.toLowerCase() == 'sí'? ", Portugués": ''}${attrs.USER_lang_other.toLowerCase() == 'sí'? `, ${translate_lang(`${attrs.USER_language_other_text}`)}`: ''}`;
    pop_insurances = `${attrs.USER_ins_bluecross.toLowerCase() == 'sí'? 'Blue Cross':''}${attrs.USER_ins_united.toLowerCase() == 'sí'? ", United":''}${attrs.USER_ins_neighborhood.toLowerCase() == 'sí'? ", Neighborhood":''}${attrs.USER_ins_tufts.toLowerCase() == 'sí'? ", Tufts":''}${attrs.USER_ins_medicaid.toLowerCase() == 'sí'? ", Medicaid": ''}${attrs.USER_ins_other.toLowerCase() == 'sí'? `, ${attrs.USER_insurance_other_text}`: ''}`;
    pop_providers = attrs.USER_providers_all.split(';').join('<br>');
    let popupHTML = `<h5>${pop_name}</h5><hr>
        <b>Dirección:</b> ${pop_address}<br>
        <b>Teléfono:</b> ${pop_phone}<br>
        <b>Sitio web:</b> <a href="${pop_website}" class="btn p-0 m-0 ${pop_clickable}" target="_blank" style="font-size:0.76rem">${pop_clickme}</a><br><br>
        <b>Se aceptan nuevo pacientes? </b>${pop_flag_newPatient}<br>
        <span class="${pop_display}"><b>Tipo de pacientes nuevos: </b>${pop_types_patients}<br></span><br>
        <b>Idioma hablado: </b>${pop_langs}<br><br>
        <b>Seguro aceptado: </b>${pop_insurances}<br><br>
        <b>Proveedores:</b><br>
        ${pop_providers}`
    return popupHTML;
}

const mapURL = "https://services.arcgis.com/8veDRDlhXWywYP3S/ArcGIS/rest/services/PediatricProviders_Spanish_11_17_2020_1/FeatureServer/0"
//create an icon for providers
let iconP = L.AwesomeMarkers.icon({
    icon: "clinic-medical",
    prefix: "fa",
    spin: false,
    markerColor: "blue"


});
//create an icon for successful locating
let iconL = L.AwesomeMarkers.icon({
    icon:"map-marker-alt",
    spin: false,
    prefix: "fa",
    iconColor: "white",
    markerColor: "orange"


});

//set up basemap
let map = L.map('map',
    {
        center: [41.825606, -71.407919],
        zoom: 13,
        zoomControl: false
    });
let zoomContorl = L.control.zoom({
    zoomInTitle: "Acercarse",
    zoomOutTitle: "Disminuir el zoom"
}).addTo(map);
const mapLink = '<a href="https://openstreetmap.org">OpenStreetMap</a>';
const userLink = '<a href="mailto:guixing_wei@brown.edu">Guixing Wei@S4</a>';
let attribution = '&copy;' + mapLink + ' Developer'+ '| &copy;' + userLink + '';
L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png',{
    attribution:attribution,
}).addTo(map);

//load wfs service
let vLayer = L.esri.featureLayer({
    url: mapURL,
    pointToLayer: function (geojson, latlng) {
        return L.marker(latlng,{icon: iconP})
    },
    onEachFeature: function (feature,layer) {
        let content = setPopVars(feature);
        layer.bindPopup(content).addTo(map);
    }

}).addTo(map);

//map locate
map.locate({
    setView: false,
    maxZoom: 13,
    enableHighAccuracy: true,
});
map.addEventListener('locationfound', function (e) {
    map.panTo(e.latlng, {animate: false});
    markerL = new L.marker(e.latlng,
        {icon: iconL,
            bounceOnAdd: true,
            bounceOnAddOptions: {duration:1500}
        })
        .bindPopup("Usted esta aquí!")
        .addTo(map);
    markerL.openPopup();



});
map.addEventListener('locationerror', function (e) {
    //alert("Unable to locate; please enable your browser's location service!");
});

//add geocoder contorl
let geocode_point;
const southWest = L.latLng(41.363407,-71.829872),
    northEast = L.latLng(42.006935,-71.250924),
    bounds = L.latLngBounds(southWest,northEast);
let geocoder = L.esri.Geocoding.geosearch({
    position: 'topleft',
    searchBounds: bounds,
    title: "Indique su direccion para realizar practicas cerca de usted",
    placeholder: "búsqueda de dirección",
    zoomToResult: false
}).addTo(map);
let geocoder_result = L.layerGroup().addTo(map);
geocoder.addEventListener('results', results=>{
    geocoder_result.clearLayers();
    if (markerL != undefined) {
        map.removeLayer(markerL);
    };
    result_1st = results.results[0].latlng;
    geocoder_result.addLayer(L.marker(result_1st, {riseOnHover:true, icon:iconL}));
    let nearest_points = get_nearest(result_1st,map, vLayer,8);
    //console.log(nearest_points);
    let nearest_bounds = L.latLngBounds(nearest_points);
    map.fitBounds(nearest_bounds);
    map.flyTo(result_1st);

});


function get_nearest(point,map,feature_layer,factor = 5){
    let arr_points = [];
    feature_layer.eachFeature(function(layer) {
        let feature = layer.feature;
        let fid_dis_point = {};
        //console.log(feature);
        let coor = {lat:feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0]};
        let point_current = L.latLng(coor);
        let id = feature.id;
        let dis = map.distance(point_current,point);
        fid_dis_point.fid = id;
        fid_dis_point.dis = dis;
        fid_dis_point.point = point_current;
        arr_points.push(fid_dis_point);
    });
    arr_points.sort((a,b)=> (a.dis > b.dis)? 1:-1);
    let top3 = arr_points.slice(0,factor);
    let bounds = [point];
    let fitbounds =[];
    top3.forEach(function (element) {
        bounds.push(element.point);
    });
    bounds.forEach(function (x) {
        fitbounds.push(Object.values(x));
    });
    return fitbounds;
};
let clear_btn = document.getElementById("clear-btn");
clear_btn.addEventListener("click", function(){
    let checks = document.querySelectorAll(".form-check-input");
    checks.forEach(function (checkbox){
        checkbox.checked = false;
    });
    vLayer.setWhere("1=1");
    })
let query_btn = document.getElementById("query-btn");
query_btn.addEventListener("click", function(){
    let checks = document.querySelectorAll(".form-check-input");
    checks = Array.from(checks);
    let checks_checked = checks.filter(el=>el.checked && el.type == "checkbox");
    let radio_checked = checks.filter(el=>el.checked && el.type == "radio");
    let query_keys = checks_checked.map(el=>el.value);
    let where_str = '1=1';
    if (query_keys.length > 0){
        query_keys.forEach(key => {where_str+=` AND ${key}='Sí'`});};
    if (radio_checked.length==1) {
        let radio_val = radio_checked[0].value;
        switch (radio_val)  {
            case "No":
                where_str+=` AND USER_acceptingnewpatients = 'No'`;
                break;
            default:
                where_str+= ` AND USER_accepting_new_type = '${radio_val}'`;
                break;
        }

    };
    //console.log(where_str);
    vLayer.setWhere(where_str);


})








